(() => {
  const heroes = document.querySelectorAll("[data-onura-hero]");

  if (!heroes.length) return;

  const canUseParallax = () => {
    return window.matchMedia("(min-width: 990px)").matches &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  };

  heroes.forEach((hero) => {
    const parallaxEnabled = hero.getAttribute("data-onura-hero-parallax") === "true";

    if (!parallaxEnabled) return;

    let frame = null;

    const resetMovement = () => {
      hero.style.setProperty("--onura-hero-move-x", "0px");
      hero.style.setProperty("--onura-hero-move-y", "0px");
    };

    const updateMovement = (event) => {
      if (!canUseParallax()) {
        resetMovement();
        return;
      }

      if (frame) {
        window.cancelAnimationFrame(frame);
      }

      frame = window.requestAnimationFrame(() => {
        const rect = hero.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;

        hero.style.setProperty("--onura-hero-move-x", `${x * -18}px`);
        hero.style.setProperty("--onura-hero-move-y", `${y * -14}px`);
      });
    };

    hero.addEventListener("mousemove", updateMovement);
    hero.addEventListener("mouseleave", resetMovement);
    window.addEventListener("resize", resetMovement);
  });
})();